import { observable, action, decorate } from 'mobx';
import SolicitarNuevaPortalidadStore from './SolicitarNuevaPortalidadStore';
import services from '../utils/ServiceUtils.js';
import ViewConstants from '../utils/ViewConstants';
import * as ErrorsUtils from '../utils/ErrorsUtils';
import * as Endpoints from '../utils/Endpoints';
import OfertasStore from './OfertasStore';
import TagManager from 'react-gtm-module';
import { load } from 'recaptcha-v3';
import { arrayBufferToBase64, base64ToArrayBuffer } from '../utils/Utils';
import PreguntasSeguridadStore from './PreguntasSeguridadStore';

class AppStore {
  navigationSection = ViewConstants.ETAPA_DATOSCLIENTE;
  recaptcha;
  loading = false;
  regiones = observable([]);
  comunas = observable([]);
  monedas = observable([]);
  solicitudesCliente = observable([]);
  totalRegistrosSolicitudes = 0;
  numSerie = '';
  rutCliente = '';
  loadingMsj = false;
  productosOferta = observable([
    {
      nombreProducto: 'Crédito de Consumo',
      selected: true,
      id: 1,
      tipo: 'CRECON',
      monto: 6000000,
      plazo: 12,
      cuota: 300000,
      montoLibre: 1500000,
      tasa: 0.4,
    },
    {
      nombreProducto: 'Tarjeta Ripley Mastercard',
      selected: true,
      id: 2,
      tipo: 'TARCRE',
      cupo: 1500000,
    },
    {
      nombreProducto: 'Cuenta Vista Cero',
      selected: true,
      id: 3,
      tipo: 'CTAVIS',
    },
  ]);

  cryptoData = {
    idKey: undefined,
    publicKey: undefined,
    expTime: undefined,
  };
  PAGE_SIZE = 4;

  constructor() {
    this.preguntaSeguridadStore = new PreguntasSeguridadStore(this);
    this.solicitarNuevaPortalidadStore = new SolicitarNuevaPortalidadStore(this);
    this.ofertasStore = new OfertasStore(this);
    window.appStore = this;
  }

  init = () => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      load(ViewConstants.RECAPTCHA_KEY).then((recaptcha) => {
        this.recaptcha = recaptcha;
        this.cargarRegiones();
      });
    } else {
      this.cargarRegiones();
    }
  };

  clearStores = () => {
    this.solicitudesCliente = observable([]);
    this.totalRegistrosSolicitudes = 0;
    this.solicitarNuevaPortalidadStore.clearStore();
  };

  setDebug(value) {
    if (value) {
      window.appstore = this;
    }
    this.debug = value;
  }

  changeNavigation(newSelection) {
    this.navigationSection = newSelection;
  }

  cargarRegiones = () => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.recaptcha.execute('cargarRegiones').then((token) => {
        this.doCargarRegiones(token);
      });
    } else {
      this.doCargarRegiones(null);
    }
  };

  doCargarRegiones = (captchaToken) => {
    let timer = setTimeout(() => {
      this.showLoading('Cargando Regiones');
    }, 500);
    services
      .get(Endpoints.REGIONES_ENDPOINT, { 'x-validation': captchaToken })
      .then(
        action('cargarRegionesOk', (response) => {
          clearTimeout(timer);
          this.hideLoading();
          let datosRegiones = [];
          response.data.forEach((region) => {
            datosRegiones.push({
              value: region.id,
              label: region.nombre,
            });
          });
          this.regiones = datosRegiones;
        })
      )
      .catch(
        action('cargarRegionesFail', (err) => {
          clearTimeout(timer);
          this.hideLoading();
          const response = err.response;
          if (response !== undefined && response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-40001);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-40001);
            }
          } else {
            ErrorsUtils.showErrorFor();
          }
        })
      );
  };

  cargarComunas = (codRegion, onCargarComunasResult) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.recaptcha.execute('cargarComunas').then((token) => {
        this.doCargarComunas(codRegion, token, onCargarComunasResult);
      });
    } else {
      this.doCargarComunas(codRegion, null, onCargarComunasResult);
    }
  };

  doCargarComunas = (codRegion, tokenRecaptcha, onCargarComunasResult) => {
    let timer = setTimeout(() => {
      this.showLoading('Cargando Comunas');
    }, 500);
    services
      .get(Endpoints.REGIONES_ENDPOINT + '/' + codRegion + '/comunas', { 'x-validation': tokenRecaptcha })
      .then(
        action('cargarComunasOk', (response) => {
          clearTimeout(timer);
          this.hideLoading();
          let datosComunas = [];
          response.data.forEach((comuna) => {
            datosComunas.push({
              value: comuna.id,
              label: comuna.nombre,
            });
          });
          this.comunas = datosComunas;
          if (onCargarComunasResult) {
            onCargarComunasResult();
          }
        })
      )
      .catch(
        action('cargarComunasFail', (err) => {
          clearTimeout(timer);
          this.hideLoading();
          const response = err.response;
          if (response !== undefined && response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-40002);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-40002);
            }
          } else {
            ErrorsUtils.showErrorFor();
          }
        })
      );
  };

  cargarMonedas = () => {
    let timer = setTimeout(() => {
      this.showLoading('Cargando Monedas');
    }, 500);
    services
      .get(Endpoints.MONEDAS_ENDPOINT)
      .then(
        action('cargarMonedas', (response) => {
          clearTimeout(timer);
          this.hideLoading();
          let datosMonedas = [];
          response.data.forEach((moneda) => {
            datosMonedas.push({
              value: moneda.id,
              label: moneda.nombre,
            });
          });
          this.monedas = datosMonedas;
        })
      )
      .catch(
        action('cargarComunasFail', (err) => {
          clearTimeout(timer);
          this.hideLoading();
          const response = err.response;
          if (response !== undefined && response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-99999);
            }
          } else {
            ErrorsUtils.showErrorFor();
          }
        })
      );
  };

  cargarSolicitudesCliente = (onResult, pageNumber = null) => {
    let timer = setTimeout(() => {
      this.showLoading('Cargando Solicitudes');
    }, 500);
    if (pageNumber == null) {
      pageNumber = 0;
    }
    services
      .get(Endpoints.SOLICITUDES_CLIENTE_ENDPOINT + '?pageSize=' + this.PAGE_SIZE + '&pageNumber=' + pageNumber)
      .then(
        action('cargarSolicitudes', (response) => {
          clearTimeout(timer);
          this.hideLoading();
          this.totalRegistrosSolicitudes = response.data.totalRegistros;
          this.solicitudesCliente.replace(response.data.solicitudes);
          if (onResult) {
            onResult();
          }
        })
      )
      .catch(
        action('cargarComunasFail', (err) => {
          clearTimeout(timer);
          this.hideLoading();
          const response = err.response;
          if (response !== undefined && response.status) {
            if (response.status === 500) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 403) {
              ErrorsUtils.showSessionInvalida();
            } else if (response.status === 400) {
              ErrorsUtils.showErrorFor(-99999);
            } else if (response.status === 404) {
              if (onResult) {
                onResult();
              }
            }
          } else {
            ErrorsUtils.showErrorFor();
          }
        })
      );
  };

  showLoading(mensaje) {
    this.mensajeLoading = mensaje;
    this.loadingMsj = true;
  }

  hideLoading() {
    this.mensajeLoading = '';
    this.loadingMsj = false;
  }

  iniciarFlujo = (rut, movil, email, serie, idRegion, idComuna, calle, numero, resto, id) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.recaptcha.execute('iniciarFlujo').then((token) => {
        this.doIniciarFlujo(rut, movil, email, serie, idRegion, idComuna, calle, numero, resto, id, token);
      });
    } else {
      this.doIniciarFlujo(rut, movil, email, serie, idRegion, idComuna, calle, numero, resto, id, null);
    }
  };

  doIniciarFlujo = (rut, movil, email, serie, idRegion, idComuna, calle, numero, resto, id, captchaToken) => {
    let timer = setTimeout(() => {
      this.showLoading('Iniciando solicitud de portabilidad.');
    }, 500);
    this.obtieneEncriptacion(async (idkey, publicKey) => {
      const serieEncriptado = await this.encripta(publicKey, serie, idkey);
      services
        .post(
          Endpoints.INIT_ENDPOINT,
          {
            rut: rut,
            email: email,
            movil: movil,
            idRegion: idRegion,
            idComuna: idComuna,
            calle: calle,
            numero: numero,
            resto: resto,
            id: id,
          },
          { 'x-validation': captchaToken, 'client-id-number': serieEncriptado }
        )
        .then(
          action('iniciarFlujoOk', (response) => {
            clearTimeout(timer);
            this.hideLoading();
            services.setToken(response.data.sessionToken);
            this.numSerie = serie;
            this.rutCliente = rut;
            this.changeNavigation(ViewConstants.ETAPA_PREGUNTASSEGURIDAD);
          })
        )
        .catch(
          action('cargarComunasFail', (err) => {
            clearTimeout(timer);
            this.hideLoading();
            if (err.response) {
              const response = err.response;
              if (response.status) {
                if (response.status === 500) {
                  ErrorsUtils.showErrorFor(response.data.resultCode);
                } else if (response.status === 400) {
                  ErrorsUtils.showErrorFor(response.data.resultCode);
                } else if (response.status === 401) {
                  ErrorsUtils.showErrorCaptcha();
                }
              }
            } else {
              ErrorsUtils.showErrorFor(-99999);
            }
          })
        );
    });
  };

  isValidKey = () => {
    let result = false;
    if (this.cryptoData && this.cryptoData.idKey && this.cryptoData.publicKey) {
      if (this.cryptoData.expTime && Date.now() < this.cryptoData.expTime) {
        result = true;
      }
    }
    return result;
  };

  obtieneEncriptacion = (callback) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.recaptcha.execute('obtieneEncriptacion').then((token) => {
        this.doObtieneEncriptacion(callback, token);
      });
    } else {
      this.doObtieneEncriptacion(callback);
    }
  };

  doObtieneEncriptacion = (callback, recaptchaToken) => {
    if (this.isValidKey()) {
      callback(this.cryptoData.idKey, this.cryptoData.publicKey);
    } else {
      services
        .get(Endpoints.GET_PUBLICKEY_ENCRYPTION, { 'x-validation': recaptchaToken })
        .then((response) => {
          if (response.status === 200) {
            this.cryptoData.idKey = response.data.idkey;
            this.cryptoData.publicKey = response.data.publicKey;
            const now = new Date();
            this.cryptoData.expTime = new Date(now.getTime() + response.data.ttl * 1000);
            callback(response.data.idkey, response.data.publicKey);
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  encripta = async (publicKey, value, idKey) => {
    const importedKey = await window?.crypto?.subtle?.importKey(
      "spki",
      base64ToArrayBuffer(publicKey),
      {
        name: "RSA-OAEP",
        hash: { name: "SHA-256" }
      },
      false,
      ["encrypt"]
    );

    const encoder = new TextEncoder();
    const encodedData = encoder.encode(value);

    const encryptedData = await window?.crypto?.subtle?.encrypt(
      {
        name: "RSA-OAEP"
      },
      importedKey,
      encodedData
    );

    return btoa(idKey + '.' + arrayBufferToBase64(encryptedData));
  };

  buscarCliente = (rut, serie, onResult, onFail) => {
    if (ViewConstants.ENABLE_RECAPTCHA === 'true') {
      this.recaptcha.execute('buscarCliente').then((token) => {
        this.doBuscarCliente(rut, serie, onResult, onFail, token);
      });
    } else {
      this.doBuscarCliente(rut, serie, onResult, onFail, null);
    }
  };

  doBuscarCliente = (rut, serie, onResult, onFail, captchaToken) => {
    this.showLoading('Buscando tus datos.');
    this.obtieneEncriptacion(async (idkey, publicKey) => {
      services
        .post(
          Endpoints.BUSCAR_CLIENTE_ENDPOINT,
          {
            rutCliente: rut,
          },
          { 'x-validation': captchaToken, 'client-id-number': await this.encripta(publicKey, serie, idkey) }
        )
        .then(
          action('buscarClienteOK', (response) => {
            this.hideLoading();
            if (onResult) {
              onResult(response.data);
            }
          })
        )
        .catch(
          action('buscarClienteError', (err) => {
            this.hideLoading();
            const response = err?.response;
            if (!response) {
              ErrorsUtils.showErrorFor(-99999);
            } else {
              const { status, data } = response;
              const resultCode = data?.resultCode;

              const handlers = {
                403: () => ErrorsUtils.showSessionInvalida(),
                500: () => ErrorsUtils.showErrorFor(resultCode),
                401: () => ErrorsUtils.showErrorCaptcha(),
                400: () => {
                  if (resultCode !== 404) {
                    ErrorsUtils.showErrorFor(resultCode);
                  }
                },
              };
              if(handlers[status]) {
                handlers[status]();
              }
            }
            if (onFail) {
              onFail();
            }
          })
        );
    });
  };

  cargarDatosCliente = (onResult, onFail) => {
    let timer = setTimeout(() => {
      this.showLoading('cargando tus datos.');
    }, 500);
    services
      .get(Endpoints.CLIENTE_ENDPOINT)
      .then(
        action('cargarDatosClienteOk', (response) => {
          clearTimeout(timer);
          this.hideLoading();
          if (onResult) {
            onResult(response.data);
          }
        })
      )
      .catch(
        action('cargarDatosClienteFail', (err) => {
          clearTimeout(timer);
          this.hideLoading();
          if (err.response) {
            const response = err.response;
            if (response.status) {
              if (response.status === 500) {
                ErrorsUtils.showErrorFor(response.data.resultCode);
              } else if (response.status === 400) {
                if (response.data.resultCode !== 404) {
                  ErrorsUtils.showErrorFor(response.data.resultCode);
                }
              } else if (response.status === 401) {
                ErrorsUtils.showSessionInvalida();
              }
            }
          } else {
            ErrorsUtils.showErrorFor(-99999);
          }
          if (onFail) {
            onFail();
          }
        })
      );
  };

  findNombreRegion = (code) => {
    let result;
    const region = this.regiones.find((item) => {
      return item.value === code;
    });
    if (region) {
      result = region.label;
    }
    return result;
  };

  findNombreComuna = (code) => {
    let result;
    const comuna = this.comunas.find((item) => {
      return item.value === code;
    });
    if (comuna) {
      result = comuna.label;
    }
    return result;
  };

  generateDataLayer = (event) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'flujoPortabilidad_event',
        eventCategory: 'flujoPortabilidad',
        eventAction: event.eventAction,
        eventLabel: event.eventLabel,
      },
    });
  };

  findMoneda = (codigo) => {
    let result = '';
    const moneda = this.monedas.find((item) => {
      return item.value === codigo;
    });
    if (moneda) {
      result = moneda.label;
    }
    return result;
  };
}

decorate(AppStore, {
  navigationSection: observable,
  loading: observable,
  changeNavigation: action,
  cargarRegiones: action,
  regiones: observable,
  comunas: observable,
  loadingMsj: observable,
  showLoading: action,
  hideLoading: action,
});

const appStore = new AppStore();
export default appStore;
window.appStore = appStore;
